import React, { useState } from "react";
import "./ScrollToTop.css";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div className="scrollButton">
      <FaArrowUp
        onClick={scrollToTop}
        style={{ display: visible ? "block" : "none" }}
        size={25}
        fill="#12519C"
      />
    </div>
  );
};

export default ScrollToTop;
